
if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        const debouncedOnChange = debounce((event) => {
          const newValue = parseInt(event.target.value) || 0;
          if (newValue === 0) {
            this.startQueue(event.target.dataset.index, newValue);
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (
            event.source === 'quick-add' ||
            (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index)))
          ) {
            return;
          }
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      get input() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.input?.addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.input?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.input?.blur();
            this.isEnterPressed = true;
          }
        });
      }

      get sectionId() {
        if (!this._sectionId) {
          this._sectionId = this.closest('.collection-quick-add-bulk').dataset.id;
        }
        return this._sectionId;
      }

      getSectionsUrl() {
        const pageParams = new URLSearchParams(window.location.search);
        const pageNumber = decodeURIComponent(pageParams.get('page') || '');
        return `${window.location.pathname}${pageNumber ? `?page=${pageNumber}` : ''}`;
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`);
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      updateMultipleQty(items) {
        this.selectProgressBar().classList.remove('hidden');

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.renderSections(parsedState, ids);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.selectProgressBar().classList.add('hidden');
            this.setRequestStarted(false);
          });
      }

      getSectionsToRender() {
        return [
          {
            id: this.sectionId, // collection section
            section: this.sectionId,
            selector: `#shopify-section-${this.sectionId}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '#shopify-section-cart-icon-bubble',
          },
          {
            id: 'CartDrawer',
            selector: '.drawer__inner',
            section: 'cart-drawer',
          },
        ];
      }
renderSections(parsedState, ids) {
  const intersection = this.queue.filter((element) => ids.includes(element.id));
  if (intersection.length !== 0) return;

  this.getSectionsToRender().forEach((section) => {
    const sectionElement = document.getElementById(section.id);
    if (!sectionElement) return;

    const newSection = new DOMParser()
      .parseFromString(parsedState.sections[section.section], 'text/html')
      .querySelector(section.selector);

    if (section.section === 'cart-drawer') {
      sectionElement.closest('cart-drawer')?.classList.toggle('is-empty', parsedState.items.length === 0);

 
      const innerDrawer = sectionElement.querySelector('.drawer__inner');
      const newInner = newSection.querySelector('.drawer__inner');

      if (innerDrawer && newInner) {
        innerDrawer.innerHTML = newInner.innerHTML;
      }
    } else {
      // normal replacement
      sectionElement.innerHTML = newSection.innerHTML;
    }
  });

  if (this.isEnterPressed) {
    this.querySelector(`#Quantity-${this.lastActiveInputId}`)?.select();
  }

  this.listenForActiveInput();
  this.listenForKeydown();
}
   
    }
  );
}
